<template>
    <!-- 会员管理－补开卡－批量导入 -->
    <div class="batch">
        <content-view v-show="$utils.renderWhen(this,'batchManage')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="vip-form">
                    <a-form-item label="导入表格名称:" :labelCol="{span: 6}" :wrapperCol="{span: 10}">
                        <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                    </a-form-item>
                    <a-form-item label="导入时间" :labelCol="{span: 6}" :wrapperCol="{span: 10}">
                        <a-range-picker style="width:100%" v-decorator="['validDate']"/>
                    </a-form-item>
                    <a-form-item label="导入操作人" :labelCol="{span: 6}" :wrapperCol="{span: 10}">
                        <a-input placeholder="请输入" v-decorator="['operateAccount']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <div class="clearfix">
                    <a-upload
                        :fileList="fileList"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                    >
                        <a-button>
                            <a-icon type="upload"/>选择文件
                        </a-button>
                    </a-upload>
                    <a-button
                        type="primary"
                        @click="handleUpload"
                        :disabled="fileList.length === 0"
                        :loading="uploading"
                        style="margin-left: 16px"
                    >{{uploading ? 'Uploading' : '批量导入' }}</a-button>
                </div>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    @change="changePage"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    style="margin-top: 20px"
                >
                    <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a
                            class="text-primary"
                            @click="toDownLoad(row)"
                        >表格详情查看</a>
                        <a-divider type="vertical"/>
                        <router-link class="text-primary" :to="{name:'failDetail', query: {id: row.id}}">失败数据查看</router-link>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'batchManage',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: "序号",
                    key: "index",
                    scopedSlots: { customRender: "index" }
                },
                {
                    title: '导入表格名称',
                    dataIndex: 'operateName'
                },
                {
                    title: '导入时间',
                    dataIndex: 'operateTime'
                },
                {
                    title: '导入操作人',
                    dataIndex: 'operateAccount',
                },
                {
                    title: '操作',
                    key: 'action',
                    scopedSlots: { customRender: 'action' }
                }
            ];
            return {
                fileList: [],
                uploading: false,
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                }
            };
        },
        computed: {},
        methods: {
            // 分页change
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getBatch();
            },
            // 搜索条件重置
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            beforeUpload(file) {
                this.fileList = [...this.fileList, file];
                return false;
            },
            handleUpload() {
                const { fileList } = this;
                const formData = new FormData();
                fileList.forEach(file => {
                    formData.append('file', file);
                });
                this.uploading = true;
                this.$api.member.batchRepairOrder({
                    body: formData
                }).then( res => {
                    this.uploading = false;
                    this.fileList = [];
                    this.getBatch();
                }).catch(err => {
                    this.uploading = false;
                })
            },
            //批量导入
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    var params = {
                        name: values.name,
                        operateAccount: values.operateAccount,
                        startDate:
                            values.validDate &&
                            values['validDate'][0].format('YYYY-MM-DD'),
                        endDate:
                            values.validDate &&
                            values['validDate'][1].format('YYYY-MM-DD')
                    };
                    this.getBatch(params);
                });
            },
            //导入记录列表
            getBatch(params) {
                var pages = {
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize
                };
                if (params) {
                    Object.assign(pages, params,);
                }
                this.$api.member.importRecord({
                    body: pages
                })
                .then(res => {
                    if (!res) return;
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                });
            },
            toDownLoad({operateUrl}) {
                window.open(operateUrl);
            },
        },

        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {
            this.getList();
        },
        mounted() {}
    };
</script>
<style lang="scss">
    .batch {
        .clearfix {
            display: flex;
            align-items: flex-start;
        }
    }
</style>